import React, { createContext, useContext } from 'react';
import posthog from 'posthog-js';

function usePosthog() {
    var init = function (_a) {
        var token = _a.token, host = _a.host;
        token && posthog.init(token, { api_host: host });
    };
    var sendEvent = function (eventName, properties) {
        posthog.capture(eventName, properties);
    };
    var sendUser = function (userId, properties) {
        posthog.identify(userId, properties);
    };
    var register = function (properties) {
        properties && posthog.register(properties);
    };
    var reset = function (flag) {
        posthog.reset(flag);
    };
    return {
        init: init,
        sendEvent: sendEvent,
        sendUser: sendUser,
        register: register,
        reset: reset,
    };
}

/* eslint-disable @typescript-eslint/no-explicit-any */
var MetricsContext = createContext({
    initMetrics: function () { },
    registerMetrics: function () { },
    resetMetrics: function () { },
    sendMetrics: function () { },
    sendIdentity: function () { },
});
function MetricsSdkProvider(_a) {
    var token = _a.token, host = _a.host, children = _a.children;
    var _b = usePosthog(), init = _b.init, sendEvent = _b.sendEvent, sendUser = _b.sendUser, register = _b.register, reset = _b.reset;
    var initMetrics = function () { return init({ token: token, host: host }); };
    var sendMetrics = function (eventName, properties) { return sendEvent(eventName, properties); };
    var sendIdentity = function (userId, properties) {
        return sendUser(userId, properties);
    };
    var registerMetrics = function (properties) {
        return register(properties);
    };
    var resetMetrics = function (flag) { return reset(flag); };
    return (React.createElement(MetricsContext.Provider, { value: {
            initMetrics: initMetrics,
            sendIdentity: sendIdentity,
            registerMetrics: registerMetrics,
            sendMetrics: sendMetrics,
            resetMetrics: resetMetrics,
        } }, children));
}
var useMetricsSdk = function () { return useContext(MetricsContext); };

export { MetricsSdkProvider, useMetricsSdk };
